import {Injectable, inject} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable, of} from 'rxjs';
import {AuthenticationService} from '../_services/authentication.service';
import {mergeMap, tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PasswordNotExpiredGuard  {
  private router = inject(Router);
  private authenticationService = inject(AuthenticationService);


  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.authenticationService.isPasswordExpired$.pipe(
      tap((isPasswordExpired: boolean) => {
        if(isPasswordExpired) {
          console.info('User\'s password is expired.  Sending to password reset.');
        }
      }),
      mergeMap((isPasswordExpired: boolean) => isPasswordExpired && of(this.router.parseUrl('/password-expired')) || of(true))
    );
  }
  
}
